import { businessSkillsActionTypes, businessSkillsReducer } from "./resume-business-skills-reducer";
import { diplomasActionTypes, diplomasReducer } from "./resume-diplomas-reducer";
import { experiencesActionTypes, experiencesReducer } from "./resume-experiences-reducer";
import { hobbiesActionTypes, hobbiesReducer } from "./resume-hobbies-reducer";
import { languageSkillsActionTypes, languageSkillsReducer } from "./resume-language-skills-reducer";
import { propertiesActionTypes, propertiesReducer } from "./resume-properties-reducer";

export const resumeActionTypes = {
    CHANGE_DOCUMENT_INTRODUCTION: 'CHANGE_DOCUMENT_INTRODUCTION',
    CHANGE_DOCUMENT_USER_FIELD: 'CHANGE_DOCUMENT_USER_FIELD',
}

export const privateActionTypes = {
    SET_VALIDATION_ERRORS: 'SET_VALIDATION_ERRORS',
    SET_RESUME_DATA: 'SET_RESUME_DATA',
}

function isActionOf( actionType, actionTypes ) {
    return Object.values( actionTypes ).includes( actionType );
}

export function resumeReducer( state, action ) {
    let updatedState = {
        ...state,
        validationErrors: {} // Always reset validationErrors on updates
    };

    if ( action.type === privateActionTypes.SET_VALIDATION_ERRORS ) {
        updatedState = {
            ...updatedState,
            validationErrors: action.payload,
        }

    } else if ( action.type === privateActionTypes.SET_RESUME_DATA ) {
        updatedState = {
            ...state,
            resumeData: action.payload,
            loaded: true,
        };

    } else if ( action.type === resumeActionTypes.CHANGE_DOCUMENT_INTRODUCTION ) {
        updatedState.resumeData.document.introduction = action.payload;

    } else if ( action.type === resumeActionTypes.CHANGE_DOCUMENT_USER_FIELD ) {
        updatedState = {
            ...updatedState,
            resumeData: {
                ...state.resumeData,
                document: {
                    ...state.resumeData.document,
                    user: {
                        ...state.resumeData.document?.user,
                        [ action.payload.name ]: action.payload.value,
                    },
                },
            },
        };

    } else if ( isActionOf( action.type, propertiesActionTypes ) ) {
        updatedState.resumeData.properties = propertiesReducer(
            state.resumeData.properties || [],
            action
        );

    } else if ( isActionOf( action.type, languageSkillsActionTypes ) ) {
        updatedState.resumeData.document.languageSkills = languageSkillsReducer(
            state.resumeData.document.languageSkills || [],
            action
        );

    } else if ( isActionOf( action.type, businessSkillsActionTypes ) ) {
        updatedState.resumeData.document.businessSkills = businessSkillsReducer(
            state.resumeData.document.businessSkills || [],
            action
        );

    } else if ( isActionOf( action.type, experiencesActionTypes ) ) {
        updatedState.resumeData.document.experiences = experiencesReducer(
            state.resumeData.document.experiences || [],
            action
        );

    } else if ( isActionOf( action.type, diplomasActionTypes ) ) {
        updatedState.resumeData.document.diplomas = diplomasReducer(
            state.resumeData.document.diplomas || [],
            action
        );

    } else if ( isActionOf( action.type, hobbiesActionTypes ) ) {
        updatedState.resumeData.document.hobbies = hobbiesReducer(
            state.resumeData.document.hobbies || [],
            action
        );
    } else {
        throw new Error( `Unknown action: [${ action.type }]` );
    }

    return updatedState;
}
